// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"DocumentCaptureButtons__buttonsContainer-BgVP"};